module.exports = __webpack_public_path__ + "img/Loa-Preview.7a0ecb20.png";